import { v4 as uuidv4 } from "uuid";
import AddInstruction from "components/recipe/AddInstruction";
import BaseButton from "base/BaseButton";
import React, { useState } from "react";

export const AddRecipeInstruction = ({ onRecipeUpdate }) => {
  const [recipeInstructions, setRecipeInstructions] = useState([]);
  const [instructionsToSave, setInstructionsToSave] = useState([]);

  const addRecipeInstruction = () => {
    const newInstruction = {
      id: uuidv4(),
      detail: "",
      minutes_to_complete: 0,
      sort_order: null,
    };
    setRecipeInstructions([...recipeInstructions, newInstruction]);
  };

  const onAdd = (instruction) => {
    //see if this is an update to an existing step
    let stepIndex = instructionsToSave.findIndex((i) => i.id == instruction.id);
    let updatedInstructions = [...instructionsToSave];
    if (stepIndex > -1) {
      updatedInstructions.splice(stepIndex, 1);
      updatedInstructions.push(instruction);
    }

    onRecipeUpdate(
      "instructions",
      stepIndex > -1
        ? [...updatedInstructions]
        : [...instructionsToSave, instruction],
    );
    setInstructionsToSave(
      stepIndex > -1
        ? [...updatedInstructions]
        : [...instructionsToSave, instruction],
    );
  };

  const removeInstruction = (instructionToRemove) => {
    //update the local instance for the UI
    setRecipeInstructions(
      recipeInstructions.filter((ri) => ri.id !== instructionToRemove.id),
    );
    //make the actual update that will be saved
    onRecipeUpdate(
      "instructions",
      instructionsToSave.filter((ri) => ri.id !== instructionToRemove.id),
    );
  };

  return (
    <section className="Column add-recipe-accordion-section">
      {recipeInstructions?.map((i, index) => {
        return (
          <AddInstruction
            instruction={i}
            key={index}
            index={index}
            onAdd={(val) => onAdd(val)}
            onRemove={() => removeInstruction(i)}
          />
        );
      })}
      <BaseButton
        buttonClass="mb-button-20"
        buttonText={recipeInstructions.length == 0 ? "Add Steps" :"Add More Steps"}
        handleClick={addRecipeInstruction}
        widthClass="w-90"
      />
    </section>
  );
};

export default AddRecipeInstruction;
